




























































































































































































































































































































    import { Vue, Component, Prop, Watch, tlISODateToLocalStringForm, tlISODateTimeToTimeOnlyString, TagService, TagFilter } from "../../Infrastructure/CorBase/CoreBase";
    import { BFormInput } from 'bootstrap-vue';


    @Component
    export default class BaseTLInput extends Vue {

        @Prop({ type: String, required: false, default: "id" }) id?: string;//id
        @Prop({ type: String, required: false, default: "" }) placeholder?: string;//info popise
        @Prop({ type: Boolean, required: false, default: true }) isVisible?: boolean; //viditelnost
        @Prop({ type: Boolean, required: false, default: false }) visiblePasswordIcon?: boolean; //viditelnost ikony pro prepinani viditelnosti hesla
        @Prop({ type: Boolean, required: false, default: true }) visiblePasswordIconType?: boolean; //pozice ikony true - vedle, false - zobrazeno vne inputu
        @Prop({ type: String, required: false, default: "" }) textLabel?: string;//popis před
        @Prop({ type: String, required: false, default: "0" }) textLabelWidth?: string;//šířka popisu
        @Prop({ type: String, required: false, default: "0" }) inputWidth?: string;// šířka input pole
        @Prop({ type: Boolean, required: false, default: false }) autoCorrect?: boolean; //autokorekce uprava datumu

          @Prop({ type: Boolean, required: false, default: false }) usePlaceholder?: boolean; //doplneni placeholderu z nazvu

        @Prop({ type: String, required: false, default: "" }) visibilityIconClassOwn?: string; //vlastni trida pro zobrazovaci ikonu hesla, je to vhodne kvuli specificke pozici

        @Prop({ type: String, required: false, default: "" }) notAllowEmails?: string; //nepovolene emaily "test@neco.cz dalsi@co.cz"

        @Prop({ type: Boolean, required: false, default: true }) addColon?: boolean; //pridani dvoutecky za nazev 

        @Prop({ type: Boolean, required: false, default: false }) notLabel?: boolean; //pouze prvek bez popisku - zatim jen dropdownlist
        @Prop({ type: Boolean, required: false, default: false }) labelTop?: boolean; //zobrazit popisek nad inputem

        @Prop({ type: Boolean, required: false, default: false }) allowNull?: boolean; //dovoli se null, napr. chci kontrolu jen rozsah cisel min, max, ale chci dat moznost prazdneho pole

        @Prop({ type: String, required: false, default: "" }) design?: string;//design - filter

        @Prop({ type: String, required: false, default: "" }) buttonName?: string;//název tlačítka
        @Prop({ type: Boolean, default: true }) showButton!: boolean; //skryti/odkryti tlačitka pouze kdyz je soucasne useButton
        @Prop(Boolean) useButton!: boolean; //použití tlačítka
        @Prop(Boolean) useDateTime!: boolean; //použití data a času - speciál se dvěmi polemi
        @Prop(Boolean) useTextArea!: boolean; //použití textArea
        @Prop({ type: Number, required: false, default: 2 }) rowsTextArea?: number; //počet řadku v textArea

        //	a) dropdown list dotažený z číselníku
        @Prop(Boolean) useEnum!: boolean; //použití enum - číselník je potřeba doplnit enumGroup
        @Prop({ type: String, required: false, default: "" }) enumGroup?: string; //typ co se ma nacist - pouze groups tak pouzit useOwnEnums
        @Prop({ type: Boolean, required: false, default: false }) enumIdSameName?: boolean; //id je stejne jako nazev

        @Prop({ type: Boolean, required: false, default: false }) useOwnEnums?: boolean; //když nechci dotahovat z ENUMS, ale poslat tam vlastni kolekci (zatim jen group )
        @Prop({ type: Boolean, required: false, default: false }) useForFilter?: boolean; //pouziti pro filtr, value se naplni jako name

        //b) drop down list - kde si sám pošlu seznam
        @Prop(Boolean) dropDownFiltred!: boolean; //dropDown s moznosti zapisu, ktery se predfiltruje - je treba useOwnEnumsSend,useOwnEnumsSendArray
        @Prop(Boolean) useOwnEnumsSend!: boolean; //použití enum - když chci vlastní hodnoty v dropdownlistu
		@Prop({ type: Boolean, required: false, default: false }) firstEmpty?: boolean; //nastaveni prvni vyberu z ciselniku je prazdný
		@Prop({ type: Number, required: false, default: "-1" }) firstEmptyValue?: String | Number | null; //hodnota pro prvni vyberu z ciselniku je prazdný
		@Prop({ type: String, required: false, default: "" }) firstEmptyLabel?: String; //text pro prvni vyberu z ciselniku je prazdný
        @Prop({ type: Array, required: false }) useOwnEnumsSendArray!: any[]; //vlastní kolekce dropDownlistu, když to nechci stahnout z číselníku
        @Prop({ type: Array, required: false }) useOwnOrder!: any[]; //vlastní řazení VZOR :  [2, 1, 0, 3];//seřazení druhu
        @Prop({ type: Boolean, required: false, default: false }) addItemAll?: boolean; //přidání položky Vše, když použiju enumGroup a chci ještě mit možnost vše
        @Prop({ type: Boolean, required: false, default: false }) dropDownFirstSelect?: boolean; //automaticky vyber prvniho prvku, nastavit na -1 formData.typeNeco
        @Prop({ type: String, required: false, default: null }) dropDownInit?: string; //defaultni nastaveni prvku pri startu dropdownu - napr. ENU_CON_TaskPart_DisplayMode_Original,nastavit na -1 formData.typeNeco

        @Prop(Boolean) useMultiselect!: boolean; //použití multiselected - např. tags


        @Prop({ type: Array, required: false }) notAllowArray!: any[]; //seznam cisel, nebo znaku ktere nejsou povoleny
        @Prop({ type: String, required: false, default: "Nelze použít tento symbol" }) errorNotAllowArrayMessage?: string;//error hlaska kdyz je nalezeno v notAllowArray
        //multiSelect

        //vzor pro useOwnEnumsSendArray
        //itemsTest = [
        //{ value: 'Ano', text: 'Ano co uvidim' },
        //{ value: 'Ne', text: 'Ne co vidím' }];

        //b) drop down list - chci podle služby
        @Prop({ type: String, required: false, default: "" }) useService?: string; //chci načíst z nějaké tabulky - tohle není optimální
        @Prop({ required: false, default: "" }) notInChoiceId?: any; //id které nechci v seznamu - převážně sám sebe

        @Prop(Boolean) useCheckbox!: boolean; //použití checkbox
		@Prop({ type: String, required: false, default: null }) tooltip?: string; //checkbox tooltip

        @Prop({ required: false }) value: any;
        @Prop({ type: Boolean, required: false, default: null }) invalid?: boolean; //TODO

        @Prop({ type: Boolean, required: false, default: false }) showNameDay?: boolean; //nazev dne u dateTime

        @Prop(Boolean) readonly!: boolean;
        @Prop(Boolean) disabled!: boolean;
        @Prop({ type: String, required: false, default: null }) max?: string; //Maximalni velikost zadaného čísla

        @Prop({ type: Number, required: false, default: 100 }) maxlengthNumber?: number;//maximalni delka number pred desetinou carkou
        @Prop({ type: Number, required: false, default: 10 }) maxDecimal?: number; //počet desetiných mist u čísla musí být type numberDec
        @Prop({ type: Boolean, required: false, default: false }) infoSmallInput?: boolean; //info hlaška, kdyz je text větši po ctrl+v Doplnit: @infoShortInput="infoShortInput" @change = "formData.name = Object($event)"

        @Prop({ type: String, required: false, default: null }) minLengthText?: string;//minimalni delka retezce, ZOBRAZI SE I ERROR HLASKA
        @Prop({ type: String, required: false, default: "20" }) maxlength?: number;//TODO funguje pouze na text
        @Prop({ type: String, required: false, default: null }) min?: string; //Minimální zadané číslo
        @Prop({ type: String, required: false, default: "text" }) type!: string; //type number, text, atd  special enum
        @Prop({ type: Boolean, required: false, default: false }) required?: boolean; //povinné pole
        @Prop(Boolean) plaintext!: boolean; //TODO
        @Prop({ type: Boolean, required: false, default: false }) state?: boolean;
        //	@Prop({ type: String, required: false, default: null }) errorMessage?: string; //error hlaška spodní, když není vyplněna tak se nezobrazí () - připadně se naplni z typeValidation
        @Prop({ type: String, required: false, default: null }) infoMessage?: string; //info hláška - kterou nahradí errorMessage
        @Prop({ type: String, required: false, default: null }) typeValidation?: string; //typ validace - password, email, number -cele číslo, numberDec -desetinné číslo, false -vypnuti, phone - telefon i s predvolbou, phoneEasy - telefon bez predvolby, psc - validace psc
        @Prop({ type: String, required: false, default: "" }) regexFormat!: string; // typ regex validace - ^[\w]{4}[-]{1}[\w]{4}[-]{1}[\w]{4}$
        @Prop({ type: String, required: false, default: "Špatný formát!" }) regexErrorMessageText!: string; // hlaska ktera se zobrazi pro uzivatele kdyz regex neni spravne
        @Prop({ type: String, required: false, default: "" }) compare?: string; //kontrola stejného hesla
        @Prop({ type: Boolean, required: false, default: true }) useErrorMessage?: boolean; //použit error message pod textboxem (default true)

        @Prop({ type: String, required: false }) minDate?: string; //jen pro datumový typ, lze určit minimální zadané datum
        @Prop({ type: String, required: false }) maxDate?: string; //jen pro datumový typ, lze určit maximální zadané datum
        @Prop({ type: Boolean, required: false, default: false }) autofocus?: boolean; //focus

        @Prop({ type: Number, required: false, default: 9 }) minLengthPassword!: number;// minimalni delka hesla
        @Prop({ type: String, required: false, default: "00:00:00" }) minTimeLength!: string; //minimalni delka casu  vzor: "00:00:10" - minimum 10 sekund

        private minLengthErrorHelp = "";
        private minLengthErrorMessage = "";
        private minDateErrorMessage = "";
        private maxDateErrorMessage = "";
        private maxValueErrorMessage = "";
        private notAllowArrayErrorMessage = "";
        private minValueErrorMessage = "";
        private passwordErrorMessage = "";
        private regexErrorMessage = "";
        private emailErrorMessage = "";
        private pscErrorMessage = "";
        private otherError = "";
        private overTimeError = "";
        private minLength = 0;
        private useInformText = false;
        private useErrorText = false;
        private useWariningText = false;
        private typeInput = '';
        private minLengthTimeErrorMessage = "";

        private timerSetting = 0;
        private dropDownInput = '';
        private initDropDownInput = false;
        //dropdown menici se
        //subselect napovedy
        //  search = [{ id: 1, text: 'Ales' }, { id: 2, text: 'Jan' }, { id: 3, text: 'Mirek' }, { id: 4, text: 'Dan' }];
        search = [{ value: -1, text: '' }];
        showSuggestion = false;
        selectSearch = { value: -1, text: '' };
        indexSelectSearch = 0;
        inputVal = '';

        lostFocus() {           
            this.$emit('blur');
        }

        getLabelText() {
            var result = "labelDetailForm";
            result = this.design == "white" ? "labelDetailFormWhite" : result;
            return result;
        }

        nameTranslate(name: string) {
            return this.$t(name).toString();
        }

        leftPosition = '0px';
        topPosition = '31px';

        lastSearchLength = 0; //pocet poslednich vysledku
        index = 0; //aktualni pozice v nabídce
        inputValIdTemp = 0;

        widthSuggestion() {
            var elementDrop = this.$refs.dropDonwElement as HTMLElement;
            if (elementDrop != undefined) {
                return (this.$refs.dropDonwElement as HTMLElement).clientWidth;
            }

            return 200;
        }

        visibilityIconClass() {
            return this.visibilityIconClassOwn + " visibilityIconPosition";
        }

        countBeforeDot(text: string): number {
            var index = text.replace(',', '.').indexOf('.');
            if (index == -1) {
                return text.length;
            }
            else {
                text = text.replace('-', '').replace(',', '.');
                var sub = text.split('.');
                return sub[0].length;
            }
        }

        countAfterDot(text: string): number {
            var index = text.replace(',', '.').indexOf('.');
            if (index == -1) {
                return 0;
            }
            else {
                text = text.replace(',', '.');
                var sub = text.split('.');
                return sub[1].length;
            }
        }

        placeholderText(){
            if (this.usePlaceholder == true) {
                return this.textLabel;
            }
            else{
                return this.placeholder          ;
            }
        }

        textLabelNormal() {
            var textWith = this.addColon == true ? this.textLabel + ":" : this.textLabel;
            return this.labelTop == true || this.usePlaceholder == true ? '' : textWith;
        }

        clickToSuggestion(item: any) {
            this.dropDownInput = item.text;
            this.showSuggestion = false;
        }

        //pri stisku klavesy - filtruje se nabídka
        keyDown(event: any) {
            if (this.showSuggestion) {
                //zmenit id na value
                if (event.key == 'ArrowDown') {
                    if (this.search.length > this.indexSelectSearch + 1) {
                        this.indexSelectSearch++;
                        this.selectSearch = this.search[this.indexSelectSearch];
                        this.inputValIdTemp = this.selectSearch.value
                    }
                    event.returnValue = false;
                }
                else if (event.key == 'ArrowUp') {
                    if (this.indexSelectSearch > 0) {
                        this.indexSelectSearch--;
                        this.selectSearch = this.search[this.indexSelectSearch];
                        this.inputValIdTemp = this.selectSearch.value;
                    }
                    event.returnValue = false;
                }
                else if (event.key == 'Enter') {
                    this.clickToSuggestion(this.search[this.indexSelectSearch]);
                    event.returnValue = false;
                }
            }
        }


        clikInputElement() {
            this.showSuggestion = true;
        }

        focusout() {
            this.timerSetting = setTimeout(() => {
                this.showSuggestion = false;
            }, 200);

        }

        @Watch('dropDownInput')
        onPropertyDropDownInputChanged(value: string, oldValue: string) {
            if (value !== oldValue) {

                if (value == '') {
                    this.search = this.useOwnEnumsSendArray;
                }
                else {
                    this.search = this.useOwnEnumsSendArray.filter((c: any) => (c.text as string).toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) != -1);
                }

                var sel = this.useOwnEnumsSendArray.filter((c: any) => c.text == value);
                if (sel.length == 0) {
                    this.model = '0';
                }
                else {

                    this.model = this.useOwnEnumsSendArray[0].value;
                }
                this.validate();
            }
        }
        @Watch('useOwnEnumsSendArray')
        onPropertyUseOwnEnumsSendArrayChanged(value: any, oldValue: any) {
            if (value !== oldValue) {
                if (this.dropDownFiltred) {
                    this.search = this.useOwnEnumsSendArray;
                    var sel = this.useOwnEnumsSendArray.filter((c: any) => c.value == (this.value as string));

                    if (sel.length > 0) {
                        this.dropDownInput = sel[0].text;
                    }
                }
            }
        }


        //end dropdown filtered


        private isKeyPress = false; //identifikace ze se nejedna o Ctrl+C, Ctrl+V
        private maxLengthInput(): number {
            var result = Number(this.maxlength);
            return result;
        }
        private maxLengthInputDis(): any {
            if (this.infoSmallInput) {
                return ''; //chci to vypnout a kontrola delky probiha jinak
            }
            else {
                return Number(this.maxlength);
            }
        }

        //pro multiSelect
        tagService: TagService = new TagService();
        options = [];
        selectedItems = [];



        initAllOptions(): void {
            let filter: TagFilter = new TagFilter(this.$store.state.idTenant, null);
            this.tagService.getAllByFilter(filter).then(response => {
                response.data.sort((a:any, b:any) => a.name.localeCompare(b.name));
                this.options = response.data;
            });
        }

        changeMultiSelect(): void {
            this.$emit('changeMultiSelect', this.id, this.selectedItems);
        }

        inputChange(item: any) {
            item = this.changeInputMax(item);
            this.$emit('change', item);
        }

        //kontrola maxiamlni delky
        changeInputMax(input: any) {
            if (this.maxLengthInput() < (input as String).length) {
                var rozdil = this.maxLengthInput() - (input as String).length;
                if (!this.isKeyPress) {
                    this.$emit('infoShortInput', this.maxLengthInput().toString());
                }
                input = (input as string).substring(0, this.maxLengthInput());
            }
            this.isKeyPress = false;
            return input;
        }


        changeCheckbox(item: any) {
            this.model = !this.model;
            this.$emit('changeCheckbox', item);
        }

        //nastaveni prvního prvku
        initItemsDropDown(items: any) {

            if (items.length > 0 && this.dropDownFirstSelect && this.model < 0) {
                this.model = items[0].value;
            }
            if (items.length > 0 && this.dropDownInit != undefined && this.model < 0) {
                this.model = (items as Array<any>).filter(c => c.key == this.dropDownInit)[0].value;
            }
        }


        clearMultiAll(): void {
            this.selectedItems = [];
        }

        clearMulti(id: any): void {
            //	const index2 = (this.selectedItems as Array<any>).indexOf((c: any) => c.id == id);
            var indexFind = 0;
            for (var i = 0; i < this.selectedItems.length; i++) {
                if ((this.selectedItems[i] as any).id == id) {
                    break;
                }
                indexFind++;
            }
            this.selectedItems.splice(indexFind, 1);
        }

        initMulti(selectItems: any): void {
            this.selectedItems = selectItems;
        }

        getNameDay() {
            if (this.type == 'date') {
                var days = [' Neděle', 'Pondělí', 'Úterý', 'Středa', ' Čtvrtek', 'Pátek', 'Sobota'];
                var dd = new Date(this.model);
                return days[dd.getDay()];
            }
            return '';
        }

        focus() {
            if (this.showInput) {
                let input: HTMLElement = this.$refs.inputValue as HTMLElement;
                input.focus();
            }
        }

        //TODO dalsi prace s cisly
        @Watch('model')
        onPropertyChangedType(value: string, oldValue: string) {
            if (value !== oldValue) {
                if ((this.typeValidation == "numberDec" || this.typeValidation == "number") && this.type != "number") {
                    if ((value as string).length > 0) {
                        this.model = (value as string).replace(',', '.');
                    }
                }

            }
        }

        controlInput(evt: any) {
            this.isKeyPress = true;
            const inputElement = evt.target;
            const selectionStart = inputElement.selectionStart;
            const selectionEnd = inputElement.selectionEnd;
            if (evt.key == 'Enter') {
                this.$emit('enterPress');
            }

            if (this.typeValidation == "psc") {
                if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57) && (evt.charCode == 32 && (this.value.toString() == 0 || this.value.toString().indexOf(' ') != -1)))
                    evt.returnValue = false;
            }

            if (this.typeValidation == "number") {
                if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57) && !(evt.charCode == 45 && this.value.toString() == 0))
                    evt.returnValue = false;
            }
            //44 a 46 dovolit.. je . a :
            if (this.typeValidation == "numberDec") {
                var newNumberText = String(this.model).substring(0, selectionStart) + evt.key + String(this.model).substring(selectionEnd);
                //kontrola neciselných znaku
                if ((evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57))) {

                    //kontrola desetine tecky	
                    if (evt.charCode == 44 || evt.charCode == 46) {
                        if ((this.value.toString().indexOf(',') == -1 && this.value.toString().indexOf('.') == -1 && this.value.toString().length > 0)) {
                            return evt.returnValue = true;
                        }
                    }
                    //kontrola pouze jednoho minusu
                    if (evt.charCode == 45) {
                        if (!(newNumberText.lastIndexOf('-') > 0)) {
                            return evt.returnValue = true;
                        }
                    }
                    return evt.returnValue = false;
                }
                else //kontrola delky cisel
                {
                    //kontrola delky cisla pred desetinou teckou				
                    if (this.countBeforeDot(newNumberText) > Number(this.maxlengthNumber)) {
                        return evt.returnValue = false;
                    }

                    //kontrola delky za čarkou
                    if (this.countAfterDot(newNumberText) > Number(this.maxDecimal)) {
                        return evt.returnValue = false;
                    }

                    //kontrola maximalni hodnoty
                    if (this.max != null) {
                        if (Number(newNumberText) > Number(this.max)) {
                            this.model = Number(this.max);
                            evt.preventDefault();
                            return false;
                        }
                    }
                    //kontrola minimalni hodnoty
                    if (this.min != null) {
                        if (Number(newNumberText) < Number(this.min)) {
                            this.model = Number(this.min);
                            evt.preventDefault();
                            return false;
                        }
                    }
                }
            }
            //if (this.typeValidation == "numberDec") {
            //    if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57) && !(evt.charCode == 45)) {
            //        if (evt.charCode == 44 || evt.charCode == 46) {
            //            var notAllow = ((this.value.toString().indexOf('.') == -1 && this.value.toString().indexOf(',') == -1) && this.value.toString().length > 0);
            //            evt.returnValue = notAllow;
            //            return notAllow;
            //        }
            //        evt.returnValue = false;
            //    }
            //}

            if (this.typeValidation == "time") {
                if ((evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 58)) || this.value.toString().length > 8)
                    evt.returnValue = false;
            }

            return true;
        }

        get errorsAll() {
            return this.regexErrorMessage + this.overTimeError + this.minLengthErrorHelp + this.minLengthErrorMessage + this.emailErrorMessage + this.otherError
                + this.passwordErrorMessage + this.minDateErrorMessage + this.maxDateErrorMessage + this.maxValueErrorMessage
                + this.minValueErrorMessage + this.notAllowArrayErrorMessage + this.pscErrorMessage + this.minLengthTimeErrorMessage;
        }


        get errorMessageText() {
            var errors = '';


            if (this.useErrorMessage) {
                this.useInformText = this.useWariningText = this.useErrorText = false;
                errors = this.errorsAll;

                if (String(this.value) == '' && this.infoMessage != '') {
                    this.useInformText = true;
                    return this.infoMessage;
                }

                if (String(this.value) == '')
                    return "";
                this.useErrorText = true;
            }
            return errors;
        }

        //načtení stylu
        get inputClass() {
            //specificky design topMenuLigh
            if (this.design == 'blackDesign') {
                return "inputDetailInputIsEditBlack";
            }
            else {
                return {
                    "inputDetailNoEdit": this.readonly,
                    "inputDetailIsEdit": !this.readonly && !this.useTextArea,
                    "inputDetailIsEditHeight": !this.readonly && !this.useTextArea && this.design != 'big',
                    "inputDetailBigLoginHeight": this.design == 'big',
                    "inputDetailFilter": this.design == 'filter',
                    "inputDetailFilterWhite": this.design == 'white',
                    "height35 stillBackgroundWhite": this.design == 'time',
                    "inputTextArea": this.useTextArea,
                    "inputDetailTextAreaIsEdit": !this.readonly && this.useTextArea,
                    "inputDetailTextAreaNoEdit": this.readonly && this.useTextArea,
                    "inputDetailColor": this.type == 'color',
                    "inputDetailHead": this.design == 'headDetail',
                    "labelDetailFormRed": this.design=='red'
                };
            }
        }

        //styl info, error, warning textů pod inputem
        get inputClassInfoMessage() {
            return {
                //	"test-color3": true
                "base-input-text-inform": this.useInformText,
                "base-input-text-warning": this.useWariningText,
                "base-input-text-error": this.useErrorText
            };
        }

        get showTextArea(): boolean {
            return this.useTextArea;
        }

        get showDateTime(): boolean {
            return this.useDateTime;
        }

        get showButtonInput(): boolean {
            return this.useButton && this.showButton;
        }

        get showInput(): boolean {
            return !(this.type == "date" && this.value == '' && this.readonly) && !this.useButton &&
                !this.useMultiselect && !this.showTextArea && !this.showCheckbox && !this.useDateTime
                && (!this.useEnum && !this.useOwnEnumsSend && this.useService == '') && !this.dropDownFiltred;
        }

        get showDropDownInput(): boolean {
            return this.dropDownFiltred;
        }

        get showDropDown(): boolean {
            return !this.showCheckbox && (this.useEnum || this.useOwnEnumsSend || this.useService != '') && !this.dropDownFiltred;
        }

        get showCheckbox(): boolean {
            if (this.useCheckbox) {

            }
            return this.useCheckbox;
        }

        created() {

            //nastavení hlašky při minimální délce
            if (this.minLengthText != undefined && this.typeValidation != "password") {
                this.minLength = this.minLength == 0 ? Number(this.minLengthText) : this.minLength;
                let mes = this.minLength == 1 ? " znak. " : "";
                mes = this.minLength > 1 && this.minLength < 5 ? " znaky. " : mes;
                mes = this.minLength >= 5 ? " znaků. " : mes;
                this.minLengthErrorHelp += "Minimální délka je " + this.minLength + mes;
            }
            this.typeInput = this.type;

            //TODO jen pro multiselect
            if (this.useMultiselect) {
                this.initAllOptions();
            }
        }

        private buttonAction(): void {
            this.$emit('clickButton');
        }

        validateRegex(input: string) {
            if (this.regexFormat.length > 0) {
                var regex = new RegExp(this.regexFormat);
                if (!regex.test(input)) {
                    this.regexErrorMessage = this.regexErrorMessageText;
                    return false;
                }
                else {
                    this.regexErrorMessage = "";
                    return true;
                }
            }
            return true;
        }

        validateMinLengthText(input: string) {
            if (this.minLengthText != undefined) {

                if (this.minLength > 0) {
                    if (input.length >= this.minLength) {
                        this.minLengthErrorMessage = "";
                        return true;
                    }
                    else {
                        this.minLengthErrorMessage = this.minLengthErrorHelp;
                        return false;
                    }
                }
            }
            //zabraneni pouze doplneni pouze mezer
            var clearInput = input.trim();
            return clearInput.length > 0;// && !this.dropDownFiltred;
        }

        existEmail(inputText: string) {
            if (this.notAllowEmails == undefined || inputText == "" || this.notAllowEmails == "") {
                return false;
            }
            else {
                 return this.notAllowEmails.indexOf(inputText) !== -1;
            }
        }

        validateEmail(input: string) {
            if (this.typeValidation == "email") {
                var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if ( input!= "" &&  this.existEmail(input)) {
                    this.emailErrorMessage = "Tento email není povolen. ";
                    return false;
                }
                else
                if (pattern.test(input)) {
                    this.emailErrorMessage = "";
                    return true;
                }
                else {
                    this.emailErrorMessage = "Špatně zadán email. ";
                    return false;
                }
            }
            return true;
        }

        validatePsc(input: string) {
            if (this.typeValidation == "psc") {
                var inputRep = input.replace(' ', '');
                if (inputRep.length < 5) {
                    this.pscErrorMessage = "Minimální delka psč je 5 znaků.";
                    return false;
                }
                else {
                    this.pscErrorMessage = "";
                    return true;
                }
            }
            return true
        }

        validatePhone(input: string) {
            const maxLength = input.indexOf('+') != -1 ? 14 : 16;
            if (this.typeValidation == "phone") {
                var pattern = /^(\+|00)? ?[1-9] ?[0-9]{0,2} ?[0-9]{3} ?[0-9]{3} ?[0-9]{3}/;
                if (pattern.test(input) && input.length >= 9 && input.length < maxLength) {
                    this.emailErrorMessage = "";
                    return true;
                }
                else {
                    this.emailErrorMessage = "Špatně zadán telefon. Formát (+420xxxxxxxxx, nebo 00420xxxxxxxxx) ";
                    return false;
                }
            }
            else if (this.typeValidation == "phoneEasy") {
                if (input.length >= 9 && input.length < maxLength) {
                    this.emailErrorMessage = "";
                    return true;
                }
                else {
                    this.emailErrorMessage = "Špatně zadán telefon. Minimální délka je 9 míst.";
                    return false;
                }
            }
            return true;
        }

        validatePassword(input: string) {
            if (this.typeValidation == "password") {
                //	var pattern = /(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9!@#\$ %\^&\*\+\-\(\)]{1,30})$/;

                var patternNumber = /\d+/;
                var patternLetterUp = /[A-Z]/;
                var patternLetterDown = /[a-z]/;

                if (patternNumber.test(input) && patternLetterUp.test(input) && patternLetterDown.test(input) && input.length >= this.minLengthPassword) {
                    this.passwordErrorMessage = "";
                    return true;
                }
                else {
                    this.passwordErrorMessage = "Heslo musí mít minimálně " + this.minLengthPassword + " znaků a obsahovat alespoň jeden velký, jeden malý znak a číslici. ";
                    return false;
                }
            }
            return true;
        }

        validatePasswordSame(input: string) {
            if (this.compare != "") {
                if (input != this.compare) {
                    this.passwordErrorMessage = "Heslo se neshoduje. ";
                    return false;
                }
                else {
                    this.passwordErrorMessage = "";
                    return true;
                }
            }
            return true;
        }

        validateTime(input: string) {

            if (this.typeValidation == "time") {
                var Hours = Number(input.split(':')[0]);
                var Minutes = Number(input.split(':')[1]);
                var Seconds = Number(input.split(':')[2]) || 0;

                let result: boolean = true;
                result = result && Hours < 24;// || (Hours == 24 && Minutes == 0 && Seconds == 0);
                result = result && Minutes < 60;
                result = result && Seconds < 60;
                //proc result = Minutes > -1 ? input.split(':')[1].length == 2 : false;

                var regex = new RegExp('^\\d{1,2}:\\d{2}(:\\d{2})?$');
                if (!result || !regex.test(input)) {
                    this.otherError = "Špatně zadán čas. Povolené formáty HH:MM:SS, nebo HH:MM";
                    return false;
                }
                else {
                    this.otherError = "";
                    return true;
                }
            }
            return true;
        }

        //možnost zadat čas ve formátu 112:22 tj. HHH:MM
        validateOverTime(input: string) {
            if (this.typeValidation == "overTime") {
                let result = true;
                result = result && input.indexOf(':') != -1;
                if (result) {
                    let cc = input.split(':');
                    result = result && (cc[0].length > 0 && Number(cc[0]) >= 0);
                    result = result && (cc[1].length > 0 && Number(cc[1]) < 60);
                }
                if (!result) {
                    this.overTimeError = "Špatně zadán čas. Povolený formát HH:MM";
                    return false;
                }
                else {
                    this.overTimeError = "";
                    return true;
                }
            }
            return true;
        }

        validateMinDate(input: string) {
            let minimumDate = (this.minDate || '');
            if (!this.autoCorrect && this.typeValidation == "date" && minimumDate.length > 9) {
                if (input.length > 9) {
                    if (new Date(input.substring(0, 10)) < new Date(minimumDate.substring(0, 10))) {
                        this.minDateErrorMessage = "Minimální povolené datum je " + minimumDate.substring(0, 10);
                        return false;
                    }
                }
            }
            return true;
        }

        validateMaxDate(input: string) {
            let maximumDate = (this.maxDate || '');
            if (!this.autoCorrect && this.typeValidation == "date" && maximumDate.length > 9) {
                if (this.prepareDateNormal(input) > this.prepareDateNormal(this.maxDate)) {
                    this.maxDateErrorMessage = "Maximální povolené datum je " + maximumDate.substring(0, 10);
                    if (new Date(input.substring(0, 10)) > new Date(maximumDate.substring(0, 10))) {
                        return false;
                    }
                }
            }
            return true;
        }

        //format resi delku ktery bootstrap má problem u čísel a datumů
        formatInput(e: any) {
            if (this.type == 'number') {
                return String(e).substring(0, Number(this.maxlength));
            }
            else if (this.type == 'date') {
                var items = String(e).split('-');
                if (items[0].length > 4) {
                    items[0] = items[0].substring(0, 4);
                }
                var result = items[0] + '-' + items[1] + '-' + items[2];
                if (items[0] == undefined || items[1] == undefined || items[2] == undefined) {
                    return e;
                }
                return result;
            }
            else {
                return e;
            }
        }

        @Watch('maxDate')
        onPropertyChangedMax(value: string, oldValue: string) {
            if (value != oldValue) {
                if (this.autoCorrect && value != undefined && value.length > 9) {
                    if (Number(value.substring(0, 4)) > 1000 &&
                        this.prepareDateNormal(this.model) > this.prepareDateNormal(value)) {
                        this.model = value;
                    }
                }
            }
        }

        @Watch('minDate')
        onPropertyChangedMin(value: string, oldValue: string) {
            if (value != oldValue) {
                if (this.autoCorrect && value != undefined && value.length > 9) {
                    if (Number(value.substring(0, 4)) > 1000 &&
                        this.prepareDateNormal(this.model) < this.prepareDateNormal(value)) {
                        this.model = value;
                    }
                }
            }
        }

        //převod na datum
        prepareDateNormal(dateString: string | undefined): Date {
            if (dateString) {
                let dateStart: Date = new Date();
                dateString = dateString.replace('-', '').replace('-', '');
                dateStart.setFullYear(Number(dateString.substr(0, 4)));
                dateStart.setMonth(Number(dateString.substr(4, 2)) - 1);
                dateStart.setDate(Number(dateString.substr(6, 2)));
                return dateStart;
            }
            return new Date();
        }

        //kontrola minimální hodnoty
        validateMinValue(input: string) {
            if ((this.typeValidation == "number" || this.typeValidation == "numberDec") && input.length > 0 && this.min != undefined) {
                var errorMessage = "Minimální hodnota je " + this.min + ". ";
                this.minValueErrorMessage = Number(this.min) > Number(input) ? errorMessage : '';
                return Number(this.min) <= Number(input);
            }
            return true;
        }

        //kontrola maximální hodnoty
        validateMaxValue(input: string) {
            if ((this.typeValidation == "number" || this.typeValidation == "numberDec") && input.length > 0 && this.max != undefined) {
                var errorMessage = "Maximální hodnota je " + this.max + ". ";
                this.maxValueErrorMessage = Number(this.max) < Number(input) ? errorMessage : '';
                return Number(this.max) >= Number(input);
            }
            return true;
        }

        //kontrola nepovolenych hodnot
        validateNotAllowArray(input: string) {
            if (this.notAllowArray != undefined) {
                if (this.notAllowArray.filter((c: any) => c == input).length > 0) {
                    this.notAllowArrayErrorMessage = this.errorNotAllowArrayMessage + " ";
                    return false;
                }
            }
            return true;
        }

        validateDate(input: string) {
            if (this.type == "date") {
                return true;
            }
            return true;
        }

        validateNumber(input: string) {
            if ((this.typeValidation == "number" || this.typeValidation == "numberDec") && input.length > 0) {
                return isNaN(Number(input)) == false;
            }
            return true;
        }


        validateMinLenthTime(input: string): boolean {
            if (this.minTimeLength != "00:00:00" && this.validateTime(input)) {
                var result = false;
                var minLengthList = (this.minTimeLength as String).split(':');
                var inputList = input.split(':');
                var sumInput = 360 * Number(inputList[0]) + 60 * Number(inputList[1]) + Number(inputList[2]);
                var sumMinLength = 360 * Number(minLengthList[0]) + 60 * Number(minLengthList[1]) + Number(minLengthList[2]);
                var result = sumMinLength <= sumInput;
                this.minLengthTimeErrorMessage = result == true ? "" : "Minimální zadaný čas je: " + this.minTimeLength;
                return result;
            }
            else {
                return true;
            }
        }

        validateDropDownFiltered() {
            if (this.dropDownFiltred) {
                return this.model != '0';
            }

            return true;
        }

        validate() {
            let inputText: string = String(this.value);

            if ((this.value == undefined || this.value == null || this.value == '') && this.allowNull == true) {
                return true;
            }

            if (this.typeValidation == 'false' || this.required == false || this.readonly) {
                return null;
            }

            if (this.value == undefined) {
                inputText = '';
            }

            let result: boolean = false;

            result = this.validateMinLengthText(inputText);
            result = result && this.validateDate(inputText);
            result = result && this.validateNotAllowArray(inputText);
            result = result && this.validateRegex(inputText);
            result = result && this.validateNumber(inputText);
            result = result && this.validateEmail(inputText);
            result = result && this.validatePhone(inputText);
            result = result && this.validatePsc(inputText);
            result = result && this.validatePassword(inputText);
            result = result && this.validatePasswordSame(inputText);
            result = result && this.validateTime(inputText);
            result = result && this.validateOverTime(inputText);
            result = result && this.validateMinDate(inputText);
            result = result && this.validateMaxDate(inputText);
            result = result && this.validateMinValue(inputText);
            result = result && this.validateMaxValue(inputText);
            result = result && this.validateDropDownFiltered();
            result = result && this.validateMinLenthTime(inputText);
            this.$emit('isCorrect', result);
            this.$emit('isCorrectWithId', result, this.id);
            this.$emit('errorText', this.errorsAll);

            return result;
        }


        get model() {
            return this.value;
        }
        set model(value: any) {
            //VaP - nekdy se na JLV stava, ze misto 0 se vrati "0", tak to zkusim takto upravit, zda to pomuze
            if (this.type == 'number') {
                let cislo = Number(value) || 0;
                this.$emit("input", cislo);
            }
            else {
                this.$emit("input", value);
            }
        }


        get prepareTime() {
            return tlISODateTimeToTimeOnlyString(this.value);
        }

        set prepareTime(value: any) {
            var datePrepare = new Date((this.$refs.datetime1 as BFormInput).value);
            var inputs = (value as string).split(':');

            datePrepare.setHours(Number(inputs[0]));
            datePrepare.setMinutes(Number(inputs[1]));

            if (!isNaN(datePrepare.getFullYear())) {
                this.$emit("input", datePrepare);
            }
        }

        get prepareDate() {
            return tlISODateToLocalStringForm(this.value);
        }

        set prepareDate(value: any) {

            var datePrepare = new Date((value as string));
            var inputs = ((this.$refs.datetime2 as BFormInput).value as string).split(':');

            datePrepare.setHours(Number(inputs[0]));
            datePrepare.setMinutes(Number(inputs[1]));

            this.$emit("input", datePrepare);
        }

        showPassword = false;
        visiblePassword(visible: boolean) {
            this.showPassword = !this.showPassword;
            if (this.showPassword) {
                this.typeInput = 'text';
            }
            else {
                this.typeInput = 'password';
            }
        }

        showPass(isVisibleIcon: boolean) {
            return this.showPassword == isVisibleIcon && this.visiblePasswordIcon == true;
        }
    }
